module.exports = __webpack_public_path__ + "static/gallery5-336edf3e97168f39647a37e42f1f4490.jpg";